<template lang="pug">
    div.bullet-wrap
        div.bullet-item(
            v-for="item in showingBullets"
            :key="item.id"
            :data-line="item.line"
            :style="{color: item.color}"
            ) {{ item.name }}
</template>

<script>
export default {
    data() {
        return {
            // 将要显示的弹幕队列
            waitBullets: [
                { id: 0, name: "Paddle Cloud", line: 0 },
                { id: 1, name: "Paddle Lite", line: 0 },
                { id: 2, name: "Paddle.js", line: 0 },
                { id: 3, name: "Paddle Serving", line: 0 },
                { id: 4, name: "Paddle Inference", line: 0 },
                { id: 5, name: "Paddle Detection", line: 0 },
                { id: 6, name: "Paddle Hub", line: 0 },
                { id: 7, name: "Paddle X", line: 0 },
                { id: 8, name: "PaddleSeg", line: 0 },
                { id: 9, name: "Paddle OCR", line: 0 },
                { id: 10, name: "Paddle Cloud", line: 0 },
                { id: 11, name: "Paddle Lite", line: 0 },
                { id: 12, name: "Paddle.js", line: 0 },
                { id: 13, name: "Paddle Serving", line: 0 },
                { id: 14, name: "Paddle Inference", line: 0 },
                { id: 15, name: "Paddle Detection", line: 0 },
                { id: 16, name: "Paddle Hub", line: 0 },
                { id: 17, name: "Paddle X", line: 0 },
                { id: 18, name: "PaddleSeg", line: 0 },
                { id: 19, name: "Paddle OCR", line: 0 }
            ],
            showingBullets: [],
            lines: 5,
            currentLine: 1,
            timer: null
        };
    },
    mounted() {
        this.showNextBullet();
        this.timer = setInterval(this.showNextBullet, 700);
    },
    methods: {
        showNextBullet() {
            if (!this.waitBullets.length) {
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                return;
            }
            // 先确定弹道，跟上一个弹道错开即可
            this.currentLine = (this.currentLine % this.lines) + 1;
            // 从等待集合里取出第一个
            const currentBullet = this.waitBullets.shift();
            // 设置弹幕的弹道
            currentBullet.line = this.currentLine;
            // 设置弹幕的颜色
            currentBullet.color = ['#000', '#87ceeb', 'pink', '#fafff0', '#40e0d0'][Math.floor(Math.random() * 4)];
            // 弹幕放进显示集合里，弹幕开始滚动
            this.showingBullets.push(currentBullet);
        }
    }
};
</script>

<style>
.bullet-wrap {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    top: 0;
}
.bullet-item {
    position: absolute;
    animation: rightToleft 6s linear both infinite;
    font-size: 22px;
    font-weight: 600;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, .3);
}
.bullet-item[data-line="1"] {
    top: 100px;
}
.bullet-item[data-line="2"] {
    top: 150px;
}
.bullet-item[data-line="3"] {
    top: 200px;
}
.bullet-item[data-line="4"] {
    top: 250px;
}
.bullet-item[data-line="5"] {
    top: 300px;
}
@keyframes rightToleft {
    0% {
        transform: translate(100vw);
    }
    100% {
        transform: translate(-100%);
    }
}
</style>
